import { render, staticRenderFns } from "./recycle.vue?vue&type=template&id=014a6b0d&scoped=true&"
import script from "./recycle.vue?vue&type=script&lang=ts&"
export * from "./recycle.vue?vue&type=script&lang=ts&"
import style0 from "./recycle.vue?vue&type=style&index=0&id=014a6b0d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014a6b0d",
  null
  
)

export default component.exports